package com.neurobs.ccabserver.transcriptreview.components.transcriptselection.components

import com.neurobs.ccab.StudyView
import com.neurobs.ccab.db.StudyData
import com.neurobs.react.semanticui.{UiDropdownFactory}
import com.neurobs.react.StyleUtil
import com.neurobs.ccabserver.transcriptreview.states.{ErrorState, TranscriptSelectionState}
import com.neurobs.js.ccab.CCABServer
import com.neurobs.js.util.ServerResponseUtil
import org.scalajs.dom.console
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.Hooks.{useEffect, useState}
import slinky.core.facade.ReactElement
import slinky.web.html._

@react
object StudySelector {

  case class Props()



  val component = FunctionalComponent[Props] { props =>

    val transcriptSelectionState = TranscriptSelectionState.accessState
    implicit val errorState = ErrorState.accessState

    val (studySelections, setStudySelections) = useState[Option[List[StudyView]]](None)


    def handleAllServerStudies = ServerResponseUtil.handleObjectResultResponse[Seq[StudyView]](
      handleObject = {studies => setStudySelections(Some(studies.toList))}
    )

    def selectStudy(study: StudyView) = {
      transcriptSelectionState.selectStudy(study)
    }

    def loadAllStudies(accountId: Long) = {
      CCABServer.getStudyViews(accountId)(handleAllServerStudies)
    }

    useEffect(() => {
      transcriptSelectionState.data.value.account match {
        case None =>
        case Some(account) =>
          loadAllStudies(account.id)
      }
    }, Vector(transcriptSelectionState.data.value.account))

    def studySelectionGenerator(study: StudyView): List[ReactElement] = {

      List(
        div(className := "item", onClick := {() => selectStudy(study)}, key := study.id.toString)(
          UiDropdownFactory.DropdownText(study.displayName),
          br(),
          UiDropdownFactory.DropdownSubtext(text = "Study type: " + study.studyTypeDisplayName)
        )
      )
    }

	  transcriptSelectionState.data.value.account match {
      case None => UiDropdownFactory.DisabledDropdown(placeholder = "Select study")
      case Some(_) => studySelections match {
        case None => UiDropdownFactory.LoadingDropdown(loadingMessage = "Loading study data")
        case Some(studies) =>
          if (studies.isEmpty) {
            UiDropdownFactory.DisabledDropdown(placeholder = "No studies found")
          } else {
            UiDropdownFactory.SelectionDropdown[StudyView](
              placeholder = "Select study",
              selections = studies,
              itemGenerator = studySelectionGenerator,
              selected = transcriptSelectionState.data.value.study,
              displayGenerator = study => study.displayName
            )
          }
      }
    }

  }
}
